import styled from 'styled-components';
import { TableContainer } from '../SummaryTablesStyles';

export const TableContainerStyled = styled(TableContainer)``;
